import AddSubAccount from './AddSubAccount';
import AccountInvitations from './AccountInvitations/index';
import AccountInvitationContainer from './AccountInvitations/AccountInvitationContainer';
import AddClientAccount from './AddClientAccount/index';
import SettingsComponent from './SettingsComponent';
import OrganisationAccountsHierarchy from './AccountHierarchy/OrganisationAccountsHierarchy';
import FamilyAccountsHierarchy from './AccountHierarchy/FamilyAccountsHierarchy';
import AddRemoveDimensionsOrAbilities from './DimensionsUpdate/AddRemoveDimensionsOrAbilities';
import UpdateTranslations from '../ItemBankManagement/UpdateTranslations';
import EnableContent from '../ItemBankManagement/EnableContent';
import AddItemBankAssessmentContent from '../ItemBankManagement/AddItemBankAssessmentContent';
import AddItemBankSurveyContent from '../ItemBankManagement/Survey/AddItemBankSurveyContent';
import AddNewCompetencyContent from '../ItemBankManagement/Survey/AddNewCompetencyContent';
import AddContentToExistingCompetency from '../ItemBankManagement/Survey/AddContentToExistingCompetency';
import UpdateSurveyCustomTranslations from '../ItemBankManagement/Survey/UpdateSurveyCustomTranslations';
import UpdateAssessmentCustomTranslations from '../ItemBankManagement/Assessment/UpdateAssessmentCustomTranslations';
import BuyOrReactivate from '../no-limit/BuyOrReactivate';
import ManageAccounts from '../no-limit/ManageAccounts';
import BuyOrReactivateOwnSubscription from '../no-limit/BuyOrReactivateOwnSubscription';
import ManageOwnSubscription from '../no-limit/ManageOwnSubscription';
import StopOwnSubscription from '../no-limit/StopOwnSubscription';
import BuySubscriptionForClient from './Subscriptions/BuySubscriptionForClient';
import StopSubscriptionForClient from '../no-limit/StopSubscriptionForClient';
import ManagedAccountDetail from '../no-limit/ManagedAccountDetail';
import AgreedCommissions from './GpiPartners/AgreedCommissions';
import SettledCommission from './GpiPartners/SettledCommission';
import InvoiceCommission from './Wallet/InvoiceCommission';
import CreateInvoiceCommission from './Wallet/CreateInvoiceCommission';
import Invoices from './Invoices';
import OrganisationInvoices from './OrganisationInvoices';
import ChangeOwnSubscription from '../no-limit/ChangeOwnSubscription';
import ChangeSubscriptionForClient from '../no-limit/ChangeSubscriptionForClient';
import Documents from './DocumentManagement/pages/Documents';
import CreateDocument from './DocumentManagement/pages/CreateDocument';
import CreateEssentialAccountInvitation from '../CreateEssentialAccountInvitation/pages/CreateEssentialAccountInvitation';
import BuyCredits from '../buy-credits/pages/BuyCredits';

const routes = [
  {
    path: '/accounts/:aid/accounts/invitations',
    component: AccountInvitations,
  },
  {
    path: '/accounts/:aid/invitations/:invitationId',
    component: AccountInvitationContainer,
  },
  {
    path: '/accounts/:aid/accounts/add-client',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-nbm-client',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-cp',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-mcp',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-gp',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-gsc',
    component: AddClientAccount,
  },
  {
    path: '/accounts/:aid/accounts/add-essential',
    component: CreateEssentialAccountInvitation,
  },
  {
    path: '/accounts/:aid/accounts/add-sub-account',
    component: AddSubAccount,
  },
  {
    path: '/accounts/:aid/settings',
    component: SettingsComponent,
  },
  {
    path: '/accounts/:aid/accounts/organisation-accounts',
    component: OrganisationAccountsHierarchy,
  },
  {
    path: '/accounts/:aid/accounts/family-accounts',
    component: FamilyAccountsHierarchy,
  },
  {
    path: '/accounts/:aid/accounts/update-dimensions',
    component: AddRemoveDimensionsOrAbilities,
  },
  {
    path: '/accounts/:aid/add-itembank-assessment-content',
    component: AddItemBankAssessmentContent,
  },
  {
    path: '/accounts/:aid/add-itembank-survey-content',
    exact: true,
    component: AddItemBankSurveyContent,
  },
  {
    path: '/accounts/:aid/add-itembank-survey-content/new',
    component: AddNewCompetencyContent,
  },
  {
    path: '/accounts/:aid/add-itembank-survey-content/update',
    component: AddContentToExistingCompetency,
  },
  {
    path: '/accounts/:aid/update-itembank-translations',
    component: UpdateTranslations,
  },
  {
    path: '/accounts/:aid/enable-content',
    component: EnableContent,
  },
  {
    path: '/accounts/:aid/update-survey-custom-translations',
    component: UpdateSurveyCustomTranslations,
  },
  {
    path: '/accounts/:aid/update-assessment-custom-translations',
    component: UpdateAssessmentCustomTranslations,
  },
  {
    path: '/accounts/:aid/buy-credits',
    component: BuyCredits,
  },
  {
    path: '/accounts/:aid/buy-subscription-for-client',
    component: BuySubscriptionForClient,
  },
  {
    path: '/accounts/:aid/buy-or-reactivate',
    component: BuyOrReactivate,
  },
  {
    path: '/accounts/:aid/manage-accounts',
    component: ManageAccounts,
  },
  {
    path: '/accounts/:aid/managed-account-details',
    component: ManagedAccountDetail,
  },
  {
    path: '/accounts/:aid/manage-own-subscription',
    component: ManageOwnSubscription,
  },
  {
    path: '/accounts/:aid/buy-or-reactivate-own-subscription',
    component: BuyOrReactivateOwnSubscription,
  },
  {
    path: '/accounts/:aid/change-own-subscription',
    component: ChangeOwnSubscription,
  },
  {
    path: '/accounts/:aid/change-subscription-for-client',
    component: ChangeSubscriptionForClient,
  },
  {
    path: '/accounts/:aid/stop-own-subscription',
    component: StopOwnSubscription,
  },
  {
    path: '/accounts/:aid/stop-subscription-for-client',
    component: StopSubscriptionForClient,
  },
  {
    path: '/accounts/:aid/agreed-commissions',
    component: AgreedCommissions,
  },
  {
    path: '/accounts/:aid/settled-commission',
    component: SettledCommission,
  },
  {
    path: '/accounts/:aid/invoice-commission',
    component: InvoiceCommission,
  },
  {
    path: '/accounts/:aid/create-invoice-commission',
    component: CreateInvoiceCommission,
  },
  {
    path: '/accounts/:aid/invoices',
    component: Invoices,
  },
  {
    path: '/accounts/:aid/organisation-invoices',
    component: OrganisationInvoices,
  },
  {
    path: '/accounts/:aid/documents',
    exact: true,
    component: Documents,
  },
  {
    path: '/accounts/:aid/documents/create',
    exact: true,
    component: CreateDocument,
  },
];

export default routes;
